
import { useEffect, useState } from "react";
import ModalBase from "../../../components/modals/ModalBase";
import apiRequest from "../../../helpers/apiRequest";
import { Urls } from "../../../utils/urls";
import { TAMModal } from "../../materials/components/AddMaterialModal";
import { TSub, TUnit } from "./ExamsConfigs";
import { PencilSquareIcon, BookOpenIcon } from "@heroicons/react/24/outline";

type TProps = {
  subject: TSub;
  onEdit: () => void;
};

const SubjectDetailsModal = ({
  isOpen,
  onClose,
  subject,
  onEdit,
}: TProps & TAMModal) => {
  const [loading, setLoading] = useState(false);
  const [units, setUnits] = useState<TUnit[]>([]);

  const getAllUnits = async () => {
    setLoading(true);
    const { data, error } = await apiRequest<TUnit[]>({
      method: "GET",
      url: `${Urls.subjects}/${subject._id}/units`,
    });
    if (error) {
      alert(error);
    } else if (data) {
      setUnits(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (isOpen) {
      getAllUnits();
    }
  }, [isOpen]);

  return (
    <ModalBase
      isOpen={isOpen}
      onClose={onClose}
      title={subject.name}
      secondaryBtn={{ title: "Close", onClick: onClose }}
    >
      <div className="mt-4 space-y-6">
        <div>
          <h4 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-3 flex items-center gap-2">
            <BookOpenIcon className="w-4 h-4" />
            Units
          </h4>
          <div className="space-y-2">
            {units?.length > 0 ? (
              units.map((unit) => (
                <div key={unit._id} className="p-3 bg-gray-50 rounded-xl border border-gray-100 text-gray-700 font-medium">
                  {unit.name}
                </div>
              ))
            ) : (
              <p className="text-gray-400 italic">No units found for this subject.</p>
            )}
          </div>
        </div>
        
        <div className="pt-4 border-t border-gray-100 flex justify-end">
            <button
              onClick={onEdit}
              className="flex items-center gap-2 text-sm font-semibold text-primary hover:text-primary/80 transition-colors"
            >
              <PencilSquareIcon className="w-4 h-4" />
              Edit Subject Details
            </button>
        </div>
      </div>
    </ModalBase>
  );
};

export default SubjectDetailsModal;
